import axios from 'axios'
// axios.defaults.baseURL = 'http://39.104.71.153:8066';

export default {
    state:{
        chooseList:[],
        chooseTime:[],
        markTime:[],
        chooseStore:'',
        choosedStoreId:'',
        chooseStoreReserveSource:'',
        chooseStoreReserveCategory:'',
        reserveCategoryDiscount:'',
        chooseSource:'',
        treeSelectShops: [],
        isFromClickMyOrderRecord: false, 
        updateOrderNow: false,
        shopIdFromSmallApp: 0,
    },
    mutations:{
        updateShopIdFromSmallApp(state,payload){
            state.shopIdFromSmallApp = payload
        },
        updateChooseList(state,obj){
            state.chooseList = obj
        },
        updateOrderNow(state, payload) {
            state.updateOrderNow = payload
        },
        updateChooseTime(state,obj){
            state.chooseTime = obj
        },
        updateChooseStore(state,obj){
            state.chooseStore = obj
        },
        updateChoosedStoreId(state,obj){
            state.choosedStoreId = obj
        },
        updateChooseStoreReserveSource(state,str){
            state.chooseStoreReserveSource = str
        },
        updateChooseStoreReserveCategory(state,str){
            state.chooseStoreReserveCategory = str
        },
        updateReserveCategoryDiscount(state,str){
            state.reserveCategoryDiscount = str
        },
        updateChooseSource(state,obj){
            state.chooseSource = obj
        },
        updateTreeSelectShops(state,obj){
            state.treeSelectShops = obj
        },
        updateIsFromClickMyOrderRecord(state, payload){
            state.isFromClickMyOrderRecord =  payload
        }
    },
    getters:{

    },
    actions:{

    }
}



// WEBPACK FOOTER //
// ./src/components/storeManage/storeManage.js